module.exports = __webpack_public_path__ + "img/defaultAvatar.38ba6878.png";